export const SmtpProviders = {
  "gmail.com": {
    serveur: "smtp.gmail.com",
    port: 465,
    description:
      "Attention, gmail demande généralement à ce qu'un mot de passe d'application soit utilisé.",
    tuto: "https://www.youtube.com/watch?v=TAt2aYM87vQ",
  },
  "outlook.com": {
    serveur: "smtp.office365.com",
    port: 587,
    description: "",
  },
  "hotmail.com": {
    serveur: "smtp.office365.com",
    port: 587,
    description: "",
  },
  "hotmail.fr": {
    serveur: "smtp.office365.com",
    port: 587,
    description: "",
  },
  "live.com": {
    serveur: "smtp.office365.com",
    port: 587,
    description: "",
  },
  "yahoo.com": {
    serveur: "smtp.mail.yahoo.com",
    port: 465,
    description: "",
  },
  "icloud.com": {
    serveur: "smtp.mail.me.com",
    port: 587,
    description: "",
  },
  "me.com": {
    serveur: "smtp.mail.me.com",
    port: 587,
    description: "",
  },
  "aol.com": {
    serveur: "smtp.aol.com",
    port: 465,
    description: "",
  },
  "protonmail.com": {
    serveur: "smtp.protonmail.ch",
    port: 465,
    description: "",
  },
  "orange.fr": {
    serveur: "smtp.orange.fr",
    port: 465,
    description: "",
  },
  "sfr.fr": {
    serveur: "smtp.sfr.fr",
    port: 465,
    description: "",
  },
  "free.fr": {
    serveur: "smtp.free.fr",
    port: 465,
    description: "",
  },
  "laposte.net": {
    serveur: "smtp.laposte.net",
    port: 465,
    description: "",
  },
  "yahoo.fr": {
    serveur: "smtp.mail.yahoo.com",
    port: 465,
    description: "",
  },
};
